import React from 'react'
import './index.scss'
import { useHistory } from "react-router-dom";

export default () => {
  let history = useHistory();

  return (
    <div className="page404">
      <div className="opt-container">
        <button className="btn" onClick={() => history.goBack()}>回到上一页</button>
        <button className="btn" onClick={() => history.push('/car-service/')}>回到首页</button>
      </div>
    </div>
  )
}